import _ from "lodash"
import { common, responsiveCSSStyle } from "./styles"

/**
 * Custom legend's options
 * See API doc: https://api.highcharts.com/highstock/legend
 * @param chartOpts
 * @returns {*}
 */
export default function legendPlugin(chartOpts) {
  _.unset(chartOpts, "legend.borderWidth")
  _.unset(chartOpts, "legend.shadow")

  _.set(chartOpts, "legend.navigation.enabled", false)
  _.set(chartOpts, "legend.backgroundColor", common.white)
  _.set(chartOpts, "legend.itemStyle", responsiveCSSStyle())
  return chartOpts
}
